import { afterNextRender, Directive, input } from '@angular/core';
import { RealtimeService } from '../pages/learner/call/library/realtime/realtime.service';

/**
 * Marks the avatar player element. Once the element is rendered, it attaches
 * the avatar tracks Daily already holds, so the player does not depend on a
 * Daily event arriving after it was created.
 */
@Directive({
  selector: '[appAvatarPlayer]',
  standalone: true,
})
export class AvatarPlayerDirective {
  readonly realtimeService = input<RealtimeService | undefined>(undefined, { alias: 'appAvatarPlayer' });

  constructor() {
    afterNextRender(() => this.realtimeService()?.attachAvatarTracks());
  }
}
